import { useContext } from "react"

import { SvgIcon } from "@components/common"
import { NewTeeupPageContext } from "@contexts/NewTeeupPageContext"

import Block from "../Block"

import "./index.scss"

// People Card Detail-Groups spec (Notion d45923fee2264c559a5512601920958c, 2026-07-05): "Shared
// Link" detail group. Spec: "reuse the existing share/settings share-link machinery read-only:
// show the link + copy; if the app has no inline share-link component, a compact row linking to
// the existing share flow." The web app's share-link machinery (components/ShareTeeUp, its own
// generate/copy/reset flow via useGenerateSharedLink) is a full settings modal that (a) fires a
// live branch.io network call on mount and (b) owns its own enable/reset toggles -- inlining that
// whole modal's body into this card would duplicate its settings controls and fire the network
// call every time the People card is opened, not "read-only show the link + copy". Chose the
// documented fallback instead: a compact row that opens that exact same modal
// (setIsShareTeeUpLinkModalOpen, already provided by NewTeeupPageContext and already the single
// source of truth TeeUpPage.js/TopBarManage.js use to mount <ShareTeeUp/>) -- one click to the
// real link + copy + QR UI, no duplicate implementation.
const SharedLink = () => {
  const { setIsShareTeeUpLinkModalOpen } = useContext(NewTeeupPageContext)

  const handleOpen = () => setIsShareTeeUpLinkModalOpen(true)

  return (
    <Block
      className="people-shared-link-group people-shared-link-clickable"
      data-testid="teeup-detail-shared-link"
      onClick={handleOpen}>
      <h4>Shared Link</h4>
      <div className="people-shared-link-row">
        <SvgIcon name="link-square" color="var(--gray4)" className="!shrink-0" />
        <span className="people-shared-link-text">
          View and copy this TeeUp's shared link
        </span>
        <SvgIcon name="arrow-2" color="var(--gray4)" className="!shrink-0" />
      </div>
    </Block>
  )
}

export default SharedLink
